import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { BuggyAssignment, BuggyCaddiePreference, BuggyData, CaddyData, CaddySelectionCriteria, ClubInfo, ClubMembershipExtended, ClubTeeTimeSlots, CurrencyData, DisplayPrices, FriendRequest, FriendRequestList, ItemizedBill, NewGameInfo, PaymentGatewayInfo, PlayerClubAccount, PlayerClubAccountStatement, PlayerClubAccountStatementPage, PlayerClubAccountTransaction, PlayerClubAccountTransactionPage, PlayerClubStat, PlayerData, PlayerHomeInfo, PlayerInfo, PlayerList, TeeTimeBooking, TeeTimeBookingOptions, TeeTimeBookingPlayer, TeeTimeSlot, TeeTimeSlotDisplay } from 'src/data/mygolf.data';
import { adjustViewZIndex } from 'src/globals';
import { PlayerPayClubMembershipPage } from '../player-pay-club-membership/player-pay-club-membership.page';
import { Observable } from 'rxjs';
import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser';
import { SessionInfo } from 'src/data/authentication-info';
import { ActionSheetController, AlertController, LoadingController, ModalController, NavController, NavParams, Platform, PopoverController, ToastController } from '@ionic/angular';
import { Keyboard } from '@ionic-native/keyboard/ngx';
import { FriendService } from 'src/providers/friend-service/friend-service';
import { HandicapService } from 'src/providers/handicap-service/handicap-service';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { PlayerHomeDataService } from 'src/redux/player-home';
import { PlayerService } from 'src/providers/player-service/player-service';
import { PaymentService } from 'src/providers/payment-service/payment-service';
import { CustomSha1 } from 'src/custom/sha1';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';
import { createPlayerList } from 'src/data/player-data';
import { AbstractNotificationHandlerPage, NotificationHandlerInfo } from 'src/providers/pushnotification-service/notification-handler-constructs';
import { Router } from '@angular/router';
import { JsonService } from 'src/json-util';
import { PlayerListClubMembershipPage } from '../player-list-club-membership/player-list-club-membership.page';
import { MessageDisplayUtil } from 'src/message-display-utils';
import { PlayerAddClubMembershipPage } from '../player-add-club-membership/player-add-club-membership.page';
import { take } from 'rxjs/operators';
import { PlayerStatementDetailsPage } from '../../modal-screens/player-statement-details/player-statement-details.page';
import { Location } from '@angular/common';
import * as global from 'src/globals';
import { MoreMenuPopoverComponent } from '../../booking/booking-details/more-menu-popover/more-menu-popover.component';



export interface BookingBuggy {
  buggySlot: number;
  driving: boolean;
  bookingPlayer?: TeeTimeBookingPlayer;
  pairingNo: number;
  walking: boolean;
  totalPlayers: number;
  maxAllowed: number;
}
export interface BookingCaddy {
  caddySelectionCriteria?: CaddySelectionCriteria;
  caddyPreferred?: CaddyData;
  caddyRequired?: false;
  caddyRequested?: boolean;
  caddyPairing?: number;
}

export interface CaddyPairing {
  caddySelectionCriteria?: CaddySelectionCriteria;
  caddyPreferred?: CaddyData;
  caddyRequired?: false;
  caddyRequested?: boolean;
  caddyPairing?: number;
}

export interface RatingItem {
  itemId?: string;
  name?: string;
  rating?: number;
}

export interface Ipay88Details {
  merchantCode?: string;
  merchantKey?: string;
}

export interface DetailsTab {
  tabName?: string;
  tabType?: number;
  expand?: boolean;
  hide?: boolean;
  orderNo?: number;
}

export interface ShowPanel {
  menu?: boolean;
  settingsMenu?: boolean;
  transactions?: boolean;
  statements?: boolean;
}

export function createPlayerClubAccountTransactionPage(): PlayerClubAccountTransactionPage {
  return {
    totalPages: 0,
    currentPage: 0,
    totalItems: 0,
    totalInPage: 0,
    success: true,
    items: []
  }
}

export function createPlayerClubAccountStatementPage(): PlayerClubAccountStatementPage {
  return {
    totalPages: 0,
    currentPage: 0,
    totalItems: 0,
    totalInPage: 0,
    success: true,
    items: []
  }
}


@Component({
  selector: 'app-player-details-club-membership',
  templateUrl: './player-details-club-membership.page.html',
  styleUrls: ['./player-details-club-membership.page.scss'],
})
export class PlayerDetailsClubMembershipPage implements OnInit {

  public friends: string = "friend";
  public friendType: string = "friend";
  public friendScreenName: string = "Friends";

  public bookings: string = "search";
  public holesPlayed: string = "2"; // 1- 9holes, 2- 18 holes


  public requestByPlayer: boolean;
  public searchPlayer: string = '';
  public searchFriend: string = '';
  public refreshAttempted: boolean = false;
  public refreshPlayer: boolean = false;

  public sentExist: boolean = false;
  public receiveExist: boolean = false;

  public playerList: PlayerList;
  public requestFriends: FriendRequestList;
  public listFriends: PlayerList;
  public receivedList: Array<FriendRequest> = new Array<FriendRequest>();
  public sentList: Array<FriendRequest> = new Array<FriendRequest>();
  public friendRequests: Array<FriendRequest> = new Array<FriendRequest>();
  public playerRequests: Array<FriendRequest> = new Array<FriendRequest>();

  public refreshOnEnter: boolean = false;

  tabs: any;

  public grpTeeSlotInfo: boolean = true;
  public grpPlayerDetails: boolean = false;
  public grpAdditionals: boolean = false;
  public grpPayment: boolean = false;
  public grpCheckIn: boolean = false;
  public grpFeedback: boolean = false;
  public grpFood: boolean = false;

  public grpDetailsTab: Array<DetailsTab> = new Array<DetailsTab>();

  teeSlotNew: boolean = true;

  teeTimeSlotDisplay: TeeTimeSlotDisplay;
  teeTimeSlot: TeeTimeSlot;

  public currentPlayer: PlayerInfo;
  public otherPlayers: Array<PlayerInfo>;
  public gameInfo: NewGameInfo;
  clubInfo: ClubInfo;
  clubs: ClubTeeTimeSlots;
  currency: CurrencyData;
  prices: DisplayPrices;
  promoPrices: DisplayPrices;

  displayPrices: boolean = false;
  isPromo: boolean = false;

  bookingSlot: TeeTimeBooking;
  nineHoles: boolean = true;

  bookingPlayers: Array<TeeTimeBookingPlayer> = new Array<TeeTimeBookingPlayer>();

  playersList: Array<PlayerInfo> = new Array<PlayerInfo>();


  public playerHomeInfo$: Observable<PlayerHomeInfo>;
  public player$: Observable<PlayerInfo>;

  currentPlayerId: number;

  groupSelected: boolean = false;

  playerSlot: Array<TeeTimeBookingPlayer> = new Array<TeeTimeBooking>();

  slots: Array<number> = []; // = [1,2,3,4];//['Slot 1', 'Slot 2', 'Slot 3', 'Slot 4']

  buggyReq: number = 0;
  caddyReq: number = 0;
  playerReq: number = 0;

  bookForOther: boolean = false;
  buggySlots: Array<BookingBuggy> = new Array<BookingBuggy>();
  caddySlots: Array<BookingCaddy> = new Array<BookingCaddy>();
  playerIsDriving: boolean = false;

  selectPaymentMethod: string = 'online'; // online, credit-card, charge-account
  paymentAmountType: string = 'full'; //full,deposit

  searchByMembership: Array<string> = new Array<string>();
  searchById: Array<number> = new Array<number>();

  clubSearchByMembership: string;
  clubSearchById: number;

  closeAdditionalNotice: boolean = false;

  expandPlayers: Array<boolean> = [false, false, false, false];
  buggySeatings: Array<BookingBuggy>;
  buggy
  caddyPairing: Array<CaddyPairing> = new Array<CaddyPairing>();
  depositAmount: number = 0;
  // playerDriving: Array<boolean> = [false,false,false,false];
  playerDriving: Array<string> = ['other', 'other', 'other', 'other'];

  bookingType: string = '';

  options: InAppBrowserOptions = {
    location: 'yes', //Or 'no' 
    hidden: 'no', //Or  'yes'
    clearcache: 'yes',
    clearsessioncache: 'yes',
    zoom: 'yes', //Android only ,shows browser zoom controls 
    hardwareback: 'yes',
    mediaPlaybackRequiresUserAction: 'no',
    shouldPauseOnSuspend: 'no', //Android only 
    closebuttoncaption: 'Close', //iOS only
    disallowoverscroll: 'no', //iOS only 
    toolbar: 'yes', //iOS only 
    enableViewportScale: 'no', //iOS only 
    allowInlineMediaPlayback: 'no', //iOS only 
    presentationstyle: 'pagesheet', //iOS only 
    fullscreen: 'yes', //Windows only    
  };

  paymentStatus: string = 'Pending';

  countdownTimer: string;

  checkInPlayers: Array<any> = [false, false, false, false, false, false];
  checkInAllPlayers: boolean = false;

  etaCounter: number = 30;
  arrivalOption: string = 'eta';

  navbar: any;
  sticky: any;

  bookingOptions: TeeTimeBookingOptions;

  uniqBuggy: any;
  uniqCaddy: any;

  buggyCaddyPreference: BuggyCaddiePreference = {};
  buggyRequired: boolean = false;
  caddyRequired: boolean = false;
  buggyRequested: number = 0;
  caddyRequested: number = 0;

  bookingItemBill: ItemizedBill;

  refresherBill: boolean = false;
  displayPayHistory: boolean = false;

  // buggyPairing: Array<any> = {}

  @ViewChild('myInput') myInput: ElementRef;
  myStuff: string = "";
  paymentClickedBoolean: boolean = false;
  asgmtDiff: boolean = false;
  caddyDiff: Array<TeeTimeBookingPlayer>;
  buggyDiff: Array<TeeTimeBookingPlayer>;
  buggiesAssigned: Array<BuggyAssignment>;

  paymentMode: boolean = false;

  clubRating: number = 0;
  bookingRating: number = 0;
  caddyRating: Array<number> = new Array<number>();
  clubRatingItems: Array<RatingItem> = new Array<RatingItem>();

  doneRating: boolean = false;
  paymentBackendURL: string;
  paymentRedirectURL: string;
  paymentCallbackURL: string;
  paymentInternalURL: string;
  paymentSignAlgo: string;
  paymentPageURL: string;
  goToPaymentURL: string;
  merchantCode = 'M27515'; //ipay88
  localBill: number;
  playerChargeAmount: number;
  afterBook: boolean = false;
  private ipay88Details: Ipay88Details;
  paymentGatewayList: Array<PaymentGatewayInfo>;
  fromClub: boolean = false;
  currSession: SessionInfo;
  clubBookingPlayers: PlayerData;
  pgDescription: string;
  paymentConfirmClickedBoolean: boolean = false;
  clubPayment: string = 'false';

  captchaResponse: string = '';

  buggyAssigned: Array<BuggyData>;

  clubMembership: ClubMembershipExtended;

  playerBalance: number = 0;
  clubCurrency: CurrencyData;

  showPanel: ShowPanel = {};
  histNextMonth: string;
  histPastDate: string;
  currentDate: string;

  histStartDate: string;
  histEndDate: string;

  stmtStartDate: string;
  stmtEndDate: string;
  stmtNextYear: string;

  histNextYear: string;

  @Input() addNew: boolean = false;
  @Input() homeClubMembership: ClubMembershipExtended;
  @Input() selectedClub: ClubMembershipExtended;
  @Input() viewSingle: boolean = true;

  constructor(
    private nav: NavController,
    private platform: Platform,
    private navParams: NavParams,
    private loadingCtrl: LoadingController,
    private modalCtl: ModalController,
    private renderer: Renderer2,
    private flightService: ClubFlightService,
    private toastCtl: ToastController,
    private cdr: ChangeDetectorRef,
    private actionSheetCtl: ActionSheetController,
    private mg2uUtil: mygolfUtils,
    private router: Router,
    private location: Location,
    private popoverCtl: PopoverController,
  ) {
    this.tabs = [{
      title: "Schedule",
      icon: "calendar"
    },
    {
      title: "Speakers",
      icon: "contacts"
    },
    {
      title: "Map",
      icon: "map"
    },
    {
      title: "About",
      icon: "information-circle"
    },
    ];

    this.requestFriends = {
      totalPages: 0,
      currentPage: 0,
      totalItems: 0,
      totalInPage: 0,
      success: true,
      friendRequests: new Array<FriendRequest>()
    };
    this.listFriends = {
      totalPages: 0,
      currentPage: 0,
      totalItems: 0,
      totalInPage: 0,
      success: true,
      players: new Array<PlayerInfo>()
    };
    // events.subscribe("FriendListUpdate", () => {
    //   // this._refreshValues(null, null);
    // });
    // events.subscribe("FriendRequestUpdate", () => {
    //   this.friends = "request";
    //   // this._refreshValues(null, null);
    // });
    this.playerList = createPlayerList();

    if (this.router.getCurrentNavigation()) {
      this.teeSlotNew = this.router.getCurrentNavigation().extras.state.teeSlotNew;
      this.bookingType = this.router.getCurrentNavigation().extras.state.type;
      this.fromClub = this.router.getCurrentNavigation().extras.state.fromClub;
      this.currSession = this.router.getCurrentNavigation().extras.state.currSession;
      this.player$ = this.router.getCurrentNavigation().extras.state.player;
    }
    else {
      this.teeSlotNew = this.navParams.get("teeSlotNew");
      this.bookingType = this.navParams.get("type");
      this.fromClub = this.navParams.get("fromClub");
      this.currSession = this.navParams.get("currSession");
      this.player$ = navParams.get('player');
    }

    this.grpDetailsTab = [
      {
        tabName: 'Membership',
        tabType: 1,
        expand: true,
        hide: false,
        orderNo: 1
      },
      {
        tabName: 'Address',
        tabType: 2,
        expand: false,
        hide: false,
        orderNo: 2
      },
      {
        tabName: 'Billing / Statements',
        tabType: 3,
        expand: false,
        hide: false,
        orderNo: 3
      },
      {
        tabName: 'Extended Info',
        tabType: 4,
        expand: false,
        hide: false,
        orderNo: 4
      },
      {
        tabName: 'Documents',
        tabType: 5,
        expand: false,
        hide: false,
        orderNo: 5
      },
      {
        tabName: 'Privacy & Approvals',
        tabType: 6,
        expand: false,
        hide: false,
        orderNo: 6
      },
      {
        tabName: 'Vehicles',
        tabType: 7,
        expand: false,
        hide: false,
        orderNo: 7
      },
      {
        tabName: 'Preferences',
        tabType: 8,
        expand: false,
        hide: false,
        orderNo: 8
      },
    ];

    this.showPanel = {
      menu: true,
      settingsMenu: false,
      transactions: false,
      statements: false,
    }


    this.histNextMonth = moment().endOf('month').format("YYYY-MM-DD");
    this.histPastDate = moment().format("YYYY-MM-DD"); //moment().add(-1, 'month').format("YYYY-MM-DD");
    this.currentDate = moment().format("YYYY-MM-DD");
    this.histStartDate = moment().add(-7, 'days').format("YYYY-MM-DD");
    this.histEndDate = moment().add(7, 'days').format("YYYY-MM-DD");
    this.stmtStartDate = moment().startOf('year').format("YYYY-MM-DD");
    this.stmtEndDate = moment().endOf('year').format("YYYY-MM-DD");
    this.histNextYear = moment(this.stmtStartDate).add(1, 'year').format("YYYY-MM-DD");
  }

  ngOnInit() {
    this.paymentMode = false;
    // if(this.homeClubMembership) {
    //   this.getClubMembership(this.homeClubMembership)
    // } else 
    if(this.selectedClub) {
      this.getClubMembership(this.selectedClub)
    } else if (!this.clubMembership) {
      this.goListClubMemberships(this.viewSingle);
    }
  }

  ngAfterViewInit() {
    console.log('all done loading :)');

    console.log(this.cdr.detectChanges())
  }
  ionViewDidEnter() {
    if (this.refreshOnEnter)
      // this._refreshValues(null, null);
      this.refreshOnEnter = false;
  }

  ionViewWillEnter() {
    adjustViewZIndex(this.nav, this.renderer);
  }
  public getNotifications(): Array<NotificationHandlerInfo> {
    let notifications = new Array<NotificationHandlerInfo>();
    notifications.push({
      type: AbstractNotificationHandlerPage.TYPE_FRIEND_REQUEST,
      whenActive: "showToast",
      whenInactive: "none",
      needRefresh: true
    });
    notifications.push({
      type: AbstractNotificationHandlerPage.TYPE_FRIEND_REQUEST_ACCEPTED,
      whenActive: "showToast",
      whenInactive: "none",
      needRefresh: true
    });
    return notifications;
  }


  getInitials(name: string) {
    // var names = name.split(' '),
    //     initials = names[0].substring(0, 1).toUpperCase();

    // if (names.length > 1) {
    //     initials += names[names.length - 1].substring(0, 1).toUpperCase();
    // }

    // return initials;
  };

  // public resolved(captchaResponse: string) {
  //     const newResponse = captchaResponse
  //       ? `${captchaResponse.substr(0, 7)}...${captchaResponse.substr(-7)}`
  //       : captchaResponse;
  //     this.captchaResponse += `${JSON.stringify(newResponse)}\n`;
  //   }

  onTooltipRecaptcha() {
    //     let _message = 'This ensures that computers / robots are unable to access our system and conduct block bookings.';
    //     let alert = this.alertCtrl.create({
    //     title: 'Recaptcha Verification',
    //     // subTitle: 'Selected date is '+ _date,
    //     message: _message, //'Selected date is ' + '<b>' + _date + '</b>',
    //     buttons: ['Close']
    // });
    // alert.present();

  }


  onNotificationsClick() {
    this.router.navigate(['notifications']);
  }

  onRefreshClick() {
    if(this.selectedClub)
      this.getClubMembership(this.selectedClub)
    else if(this.clubMembership) this.getClubMembership(this.clubMembership)
  }

  toggleDetailsBoxClick(type: number) {
    this.grpDetailsTab.forEach((grp) => {

      if (grp.tabType === type)
        grp.expand = !grp.expand
      else grp.expand = false;
    });
  }



  showDetailsBox(type: number) {
    let _show;
    if (!type) _show = false;
    else if (type) {
      if (this.grpDetailsTab && this.grpDetailsTab.length === 0) _show = false;
      else if (!this.grpDetailsTab) _show = false;
      else {
        this.grpDetailsTab.filter((grp: DetailsTab) => {
          return grp.tabType === type
        }).map((grp: DetailsTab) => {
          _show = !grp.hide
        })
      }
    }
    return _show;

  }

  getDetailsInfo(type: number, attribute: string) {
    let _grpDetails: DetailsTab;
    this.grpDetailsTab.filter((grp: DetailsTab) => {
      return grp.tabType === type
    }).map((grp: DetailsTab) => {
      _grpDetails = grp
    });
    // console.debug("get details info [",type,"] - ", attribute + " : ",_grpDetails )
    switch (attribute) {
      case 'name':
        return _grpDetails && _grpDetails.tabName
      case 'expand':
        return _grpDetails && _grpDetails.expand
      default:
        break;
    }
  }

  async goListClubMemberships(init?: boolean) {

    let clubListModal = await this.modalCtl.create({
      component: PlayerListClubMembershipPage,
      componentProps: {
        openedModal: true,
        forBooking: true,
        addNew: this.addNew,
        init: init
      }
    });
    clubListModal.onDidDismiss().then((data: any) => {
      //Check whether the club info is passed
      console.debug("club membership selected : ", data, this.clubMembership)
      if (data?.data) {
        if(data?.data?.mode === 'viewStat') {
          
          this.clubMembership = data?.data?.membership;
          // JsonService.deriveFulImageURL(this.clubMembership, "memberImage");
          // JsonService.deriveFulImageURL(this.clubMembership.player, "image");
          // JsonService.deriveFulImageURL(this.clubMembership.player.userProfile, "profileImage");
          // JsonService.deriveFulImageURL(this.clubMembership.club, "clubImage");
          // JsonService.deriveFulImageURL(this.clubMembership.club, "clubLogo");
          // JsonService.deriveFulImageURL(this.clubMembership.club, "clubThumbnail");
          this.currentPlayerId = this.clubMembership.player.id;
          this.getPlayersCredits(this.currentPlayerId, this.clubMembership.club.id);
          this.getPlayerClubStatements(null, true);
          this.getPlayerClubAccount();
          this.getPlayerClubStats(1);
          setTimeout(()=>{
            this.onClickShowStatements();
          },500)
          return;
        }
        // let clubMembership = JsonService.clone(data);
        this.clubMembership = data.data; //clubMembership;
        // JsonService.deriveFulImageURL(this.clubMembership, "memberImage");
        // JsonService.deriveFulImageURL(this.clubMembership.player, "image");
        // JsonService.deriveFulImageURL(this.clubMembership.player.userProfile, "profileImage");
        // JsonService.deriveFulImageURL(this.clubMembership.club, "clubImage");
        // JsonService.deriveFulImageURL(this.clubMembership.club, "clubLogo");
        // JsonService.deriveFulImageURL(this.clubMembership.club, "clubThumbnail");
        this.currentPlayerId = this.clubMembership.player.id;
        this.getPlayersCredits(this.currentPlayerId, this.clubMembership.club.id);
        this.getPlayerClubStatements(null, true);
        this.getPlayerClubAccount();
        this.getPlayerClubStats(1);

        console.debug("club membership selected : ", this.clubMembership)
        this.onBackToMenu();
      } else if(!this.clubMembership || this.clubMembership === undefined) {
        this.backRouting();
      } else this.backRouting();
      // else clubListModal.present();
    });
    clubListModal.present();
  }
  
  getClubMembership(clubMembership) {
    
        this.clubMembership = clubMembership; 
        // JsonService.deriveFulImageURL(this.clubMembership, "memberImage");
        // JsonService.deriveFulImageURL(this.clubMembership.player, "image");
        // JsonService.deriveFulImageURL(this.clubMembership.player.userProfile, "profileImage");
        // JsonService.deriveFulImageURL(this.clubMembership.club, "clubImage");
        // JsonService.deriveFulImageURL(this.clubMembership.club, "clubLogo");
        // JsonService.deriveFulImageURL(this.clubMembership.club, "clubThumbnail");
        this.currentPlayerId = this.clubMembership.player.id;
        this.getPlayersCredits(this.currentPlayerId, this.clubMembership.club.id);
        this.getPlayerClubStatements(null, true);
        this.getPlayerClubAccount();
        this.getPlayerClubStats(1);
        this.refreshClubMembership();
  }

  getPlayersCredits(playerId: number, clubId: number) {
    let _playerId;
    let _clubId;
    let _balance;
    if (!clubId || !playerId) return false;
    if (playerId) _playerId = playerId;
    if (clubId) _clubId = clubId;



    // else _playerId = _player.playerId;
    // this.bookingSlot.bookingPlayers.forEach((p,i)=>{
    this.flightService.getPlayerClubCredits(_playerId, _clubId)
      .subscribe((data) => {
        if (data) {
          //  console.debug("get player club credits - ",_playerId+" : "+ data.balance)
          this.playerBalance = data.balance;
          this.clubCurrency = data.currency;
          this.playerAccountDetails = data;

          // if(this.fromClub) this.playersBalance += data.balance;
          // else if(!this.fromClub) this.playersBalance = data.balance;
          // this.creditBalancePlayers[i] = data.balance;
        }
      });
    // return _balance;
    // })
  }

  onClickShowTransactions() {
    this.showPanel.menu = false;
    this.showPanel.transactions = true;
    this.getPlayerClubTransactions();
  }

  onClickSettingsMenu() {
    MessageDisplayUtil.showErrorToast('This feature will be available in the future', this.platform, this.toastCtl,
      5000, "bottom");
    if (1) return;
    this.showPanel.menu = false;
    this.showPanel.settingsMenu = true;
  }

  onBackToMenu() {
    this.showPanel.menu = true;
    this.showPanel.transactions = false;
    this.showPanel.settingsMenu = false;
    this.showPanel.statements = false;
  }

  onClickShowStatements() {
    this.showPanel.menu = false;
    this.showPanel.statements = true;
    this.getPlayerClubStatements();
    this.getPlayerClubStats();
  }

  historyMonthly: boolean = true;
  historyYearly: boolean = false;
  playerClubTransactions: PlayerClubAccountTransactionPage;
  playerClubTransactionPage: PlayerClubAccountTransactionPage;
  async getPlayerClubTransactions(infinite?) {
    let _params;
    let _startDate = moment(this.histPastDate).startOf('month').format('YYYY-MM-DD');
    // let _startDate = moment().subtract(1, 'week').format("YYYY-MM-DD");
    // let _endDate = moment().format("YYYY-MM-DD");
    let _endDate = moment(this.histPastDate).endOf('month').format('YYYY-MM-DD');
    let _trxnView = 'B';
    let _pageNo = 1;
    if (infinite && this.playerClubTransactionPage) _pageNo = this.playerClubTransactionPage.currentPage + 1;

    if (this.trxnView) _trxnView = this.trxnView;

    if (0 && this.historyMonthly && this.histNextMonth) _endDate = this.histNextMonth;
    // if(this.historyMonthly) {

    // }
    if (!this.historyMonthly) {
      _startDate = this.histStartDate;
      _endDate = this.histEndDate;
    }
    console.debug("get player club transactions : ", _startDate, _endDate);
    _params = {
      clubId: this.clubMembership.club.id,
      playerId: this.clubMembership.player.id,
      includedInStmt: _trxnView, //Y | N | B
      search: '',
      startDate: _startDate,
      endDate: _endDate,
      pageSize: 30,
      pageNo: _pageNo
    }

    if (!infinite) this.playerClubTransactionPage = createPlayerClubAccountTransactionPage();
    console.debug("get player club transactions : ", _params);
    let loader = this.loadingCtrl.create({
      showBackdrop: false
    });
    (await loader).present().then(() => {
      this.flightService.getPlayerClubTransactions(_params)
        .subscribe(async (data: PlayerClubAccountTransactionPage) => {
          if (data) {
            console.debug("Player Club Transactions : ", data)
            // this.playerClubTransactions = data;
            // this.playerClubTransactionPage = data;
            this.playerClubTransactionPage.currentPage = data.currentPage;
            this.playerClubTransactionPage.totalPages = data.totalPages;
            this.playerClubTransactionPage.totalItems = data.totalItems;
            this.playerClubTransactionPage.items.push(...data.items);
          }
          if (loader) (await loader).dismiss();
        }, async (error) => {
          if (loader) (await loader).dismiss();
        }, () => {
          // if(loader) loader.dismiss();
          if (infinite) {
            if (infinite.target.complete) infinite.target.complete();
            if (this.isMore()) {
              infinite.target.enable(true);
            }
            else infinite.target.enable(false);
          }
        });
    })


  }

  playerClubStatements: PlayerClubAccountStatementPage;
  playerClubStatementPage: PlayerClubAccountStatementPage;
  latestPlayerStatement: Array<PlayerClubAccountStatement>;
  async getPlayerClubStatements(infinite?, latestOnly: boolean = false) {
    let _params;
    let _startDate: string = '';
    let _endDate: string = '';


    if (!this.historyYearly) {

      // _startDate = moment(this.stmtStartDate).subtract(this.stmtLastNMonths, 'months').format("YYYY-MM-DD");
      _startDate = moment().startOf('month').subtract(this.stmtLastNMonths, 'months').format("YYYY-MM-DD");
      // _endDate = moment(this.stmtEndDate).endOf('month').format("YYYY-MM-DD");
      _endDate = moment().format("YYYY-MM-DD");
    } else if (this.historyYearly) {
      _startDate = moment(this.stmtStartDate).startOf('year').format('YYYY-MM-DD');
      _endDate = moment(this.stmtEndDate).endOf('year').format('YYYY-MM-DD');
    }

    // let _startDate = moment().subtract(1, 'week').format("YYYY-MM-DD");
    // let _endDate = moment().format("YYYY-MM-DD");
    let _pageNo = 1;
    if (infinite && this.playerClubStatementPage) _pageNo = this.playerClubStatementPage.currentPage + 1

    // if(0 && this.historyMonthly && this.histNextMonth) _endDate = this.histNextMonth;
    // else if(!this.historyMonthly) {
    //     _startDate = this.histStartDate;
    //     _endDate = this.histEndDate;
    // }
    console.debug("get player club transactions : ", _startDate, _endDate);
    _params = {
      clubId: this.clubMembership.club.id,
      playerId: this.clubMembership.player.id,
      latestOnly: latestOnly,
      search: '',
      startDate: _startDate,
      endDate: _endDate,
      pageSize: 30,
      pageNo: _pageNo
    }
    let loader = this.loadingCtrl.create({
      showBackdrop: false
    });

    if (latestOnly) this.latestPlayerStatement = [];

    if (!infinite) this.playerClubStatementPage = createPlayerClubAccountStatementPage();

    (await loader).present().then(() => {
      this.flightService.getPlayerClubStatements(_params)
        .subscribe(async (data: PlayerClubAccountStatementPage) => {
          if (data) {
            console.debug("Player Club Transactions : ", data)
            // this.playerClubStatements = data;
            // this.playerClubStatementPage = data;
            if (!latestOnly) {
              this.playerClubStatementPage.currentPage = data.currentPage;
              this.playerClubStatementPage.totalPages = data.totalPages;
              this.playerClubStatementPage.totalItems = data.totalItems;
              this.playerClubStatementPage.items.push(...data.items);
            } else if (latestOnly) {
              this.latestPlayerStatement.push(...data.items);
            }
          }
          if (loader) (await loader).dismiss();
        }, async (error) => {
          if (loader) (await loader).dismiss();
        }, () => {
          if (infinite) {
            if (infinite.target.complete) infinite.target.complete();
            if (this.isMore()) {
              infinite.target.enable(true);
            }
            else infinite.target.enable(false);
          }
        });
    })
  }

  nextDate(type?: string) {
    let _pastMonth = moment(this.histPastDate).endOf('month').format('YYYY-MM-DD');
    // let _cancelMonth = moment(this.cancelPastDate).endOf('month').format('YYYY-MM-DD');

    if (type === 'past') this.histPastDate = moment(this.histPastDate).add(1, 'month').format("YYYY-MM-DD");
    else if (type === 'stmt') {
      this.stmtStartDate = moment(this.stmtStartDate).add(1, 'year').format("YYYY-MM-DD");
      this.stmtEndDate = moment(this.stmtEndDate).add(1, 'year').format("YYYY-MM-DD");
    }
    // if(type === 'cancel') this.cancelPastDate = moment(this.cancelPastDate).add(1, 'month').format("YYYY-MM-DD");
    // else this.currentDate = moment(this.currentDate).add(1, 'days').format("YYYY-MM-DD");
  }

  prevDate(type?: string) {
    if (type === 'past') 
      this.histPastDate = moment(this.histPastDate).subtract(1, 'month').format("YYYY-MM-DD");
    else if (type === 'stmt') {
      console.debug("prev date : ", this.stmtStartDate, this.stmtEndDate)
      this.stmtStartDate = moment(this.stmtStartDate).subtract(1, 'year').format("YYYY-MM-DD");
      this.stmtEndDate = moment(this.stmtEndDate).subtract(1, 'year').format("YYYY-MM-DD");
    }
    // else if(type === 'cancel') this.cancelPastDate = moment(this.cancelPastDate).subtract(1, 'month').format("YYYY-MM-DD");

    // else this.currentDate = moment(this.currentDate).subtract(1, 'days').format("YYYY-MM-DD");
  }

  confirmDate(type?: string) {
    if (type === 'today') {
    } else if (type === 'future') {
    } else if (type === 'past') {
      console.debug("confirm date ", moment(this.histEndDate).diff(moment(this.histStartDate), 'months'))
      if (!this.historyMonthly && this.getDateDiff(this.histStartDate, this.histEndDate, 'months') > 6) {
        // moment(this.histEndDate).diff(moment(this.histStartDate),'months') > 6
        this.playerClubTransactionPage = createPlayerClubAccountTransactionPage();
        MessageDisplayUtil.showErrorToast('Please specify date period not more than 6 months', this.platform, this.toastCtl,
          5000, "bottom");
        return;
      }
      this.getPlayerClubTransactions();
    } else if (type === 'cancel') {
    } else if (type === 'stmt') {
      this.playerClubTransactionPage = createPlayerClubAccountTransactionPage();
      // if(this.historyYearly) {
      //   this
      // }
      this.getPlayerClubStatements();
    }
  }

  getDateDiff(start: string, end: string, unitOfTime: moment.unitOfTime.Diff) {
    return moment(end).diff(moment(start), unitOfTime);
  }

  nextPage(type?: string) {
    // if(type === 'cancel') {
    //     let _cancelMonth = moment(this.cancelPastDate).endOf('month').format('YYYY-MM-DD');
    //     if (moment(_cancelMonth).isSameOrAfter(moment(this.cancelNextMonth).endOf('month'),'month')) return false;
    //     else return true;
    //     } else {
    if (type === 'past') {
      let _pastMonth = moment(this.histPastDate).endOf('month').format('YYYY-MM-DD');
      if (moment(_pastMonth).isSameOrAfter(moment(this.histNextMonth).endOf('month'), 'month')) return false;
      else return true;

    } else if (type === 'stmt') {

      let _stmtYear = moment(this.stmtStartDate).add(1, 'year').format('YYYY-MM-DD');
      if (moment(_stmtYear).isSameOrAfter(moment(this.histNextYear), 'year')) return false;
      else return true;
    }
  }

  getClubImage() {
    // console.debug("get club image [0] : ", this.clubMembership)
    if (!this.clubMembership) return 'img/default_club.png';
    let _clubImage = '';
      if (this.clubMembership?.club) {
        if (this.clubMembership.club.clubLogo) _clubImage = this.clubMembership.club.clubLogo;
        else if (this.clubMembership.club.clubImage) _clubImage = this.clubMembership.club.clubImage;
        else if (this.clubMembership.club.clubThumbnail) _clubImage = this.clubMembership.club.clubThumbnail;
        else return 'img/default_club.png';
      }

    // console.debug("get club image [1] : ", _clubImage)
    if(_clubImage.toLowerCase().includes(global.MygolfServerHost.toLowerCase()))
      return _clubImage
    else return global.MygolfServer + '/' + _clubImage;
  }

  getTransactionDetails(transaction: PlayerClubAccountTransaction, attribute?: string) {
    if (!attribute) return;
    if (!transaction) return;
    let _currency = transaction.playerClubAccount.currency.symbol;
    let _amount = 0;
    let _isCredit = transaction.debitOrCredit === 'Credit' ? true : false;
    let _negativeSymbol = '';
    _amount = transaction.amount;

    switch (attribute) {
      case 'amount':
        if (transaction.chargeType.toLowerCase().includes('payment'))
          _negativeSymbol = _isCredit ? "-" : "+";
        // _amount = _isCredit?-1*transaction.amount:transaction.amount;
        else if (transaction.chargeType.toLowerCase().includes('refund'))
          _negativeSymbol = _isCredit ? "+" : "-";
        // _amount = _isCredit?transaction.amount:-1*transaction.amount;
        return _currency + ' ' + _amount.toFixed(2);
      case 'description':
        let _description = '';
        // _description += transaction.chargeType + ' of '
        // _description += ' ' + _currency + ' ' + _amount.toFixed(2);
        _description = transaction.description
        return _description;
      // return transaction.description;
      case 'reference':
        if (!transaction.reference) return;
        return '(' + transaction.reference + ')';
      case 'transactionDate':
        return moment(transaction.transactionDate).format("ddd, DD MMM YYYY")
      case 'debitOrCredit':
        return transaction.debitOrCredit;
    }
  }

  getAmountClass(transaction: PlayerClubAccountTransaction) {
    if (transaction.debitOrCredit.toLowerCase() === 'credit') return 'credit-amount';
    else if (transaction.debitOrCredit.toLowerCase() === 'debit') return 'debit-amount';
    else return '';
  }

  getStatementDetails(statement: PlayerClubAccountStatement, attribute?: string) {
    if (!attribute) return;
    if (!statement) return;
    let _currency = statement.club.address.countryData.currencySymbol;
    let _amount = 0;
    // let _isCredit = statement.debitOrCredit==='Credit'?true:false;
    let _negativeSymbol = '';

    switch (attribute) {
      // case 'amount':
      //     _amount = statement.amount;
      //     if(statement.chargeType.toLowerCase().includes('payment')) 
      //         _negativeSymbol = _isCredit?"-":"+";
      //     // _amount = _isCredit?-1*transaction.amount:transaction.amount;
      //     else if(statement.chargeType.toLowerCase().includes('refund')) 
      //         _negativeSymbol = _isCredit?"+":"-";
      //     // _amount = _isCredit?transaction.amount:-1*transaction.amount;
      //     return _negativeSymbol + ' ' + _currency + ' ' + _amount.toFixed(2);
      case 'description':
        // return statement.name;
        return moment(statement.statementDate, "YYYY-MM-DD").format("MMMM YYYY")
      case 'statementDate':
        return moment(statement.statementDate, "YYYY-MM-DD").format("MMMM YYYY");
      case 'statementDateDetail':
        return moment(statement.statementDate, "YYYY-MM-DD").format("DD MMM YYYY");
      case 'closingBalance':
        return _currency + ' ' + this.mg2uUtil.numberWithCommas(statement.closingBalance.toFixed(2));
      case 'balanceBroughtForward':
        return _currency + ' ' + this.mg2uUtil.numberWithCommas(statement.balanceBroughtForward.toFixed(2));
    }
  }

  getCurrentDate() {
    return moment().format("DD MMM YYYY");
  }

  getClubStatementList() {
    if (!this.playerClubStatementPage) return [];
    if (this.playerClubStatementPage && this.playerClubStatementPage.totalItems === 0) return [];
    let _filteredList: Array<PlayerClubAccountStatement> = [];

    // _filteredList.items.filter((statement: PlayerClubAccountStatement)=>{
    //     return statement.approved
    // });
    _filteredList = this.playerClubStatementPage.items.filter((statement: PlayerClubAccountStatement) => {
      // return true;
      return statement.approved
    });

    // console.debug("club statement list : ", _filteredList)
    // console.debug("club statement list : ", this.playerClubStatements)
    return _filteredList;
  }

  transactionUnbilled;
  getClubTransactionList() {
    if (!this.playerClubTransactionPage) return [];
    if (this.playerClubTransactionPage && this.playerClubTransactionPage.totalItems === 0) return [];
    let _filteredList: Array<PlayerClubAccountTransaction> = [];
    _filteredList.push(...this.playerClubTransactionPage.items);
    let billed = !this.transactionUnbilled;

    // _filteredList.items.filter((statement: PlayerClubAccountStatement)=>{
    //     return statement.approved
    // });
    // _filteredList = this.playerClubTransactions.items.filter((transaction: PlayerClubAccountTransaction)=>{
    //         if(billed) return transaction.includedInStatement
    //         else return true
    // });
    console.debug("club transaction list : ", _filteredList)
    return _filteredList;
  }

  trxnView: string = 'B'
  displayTrxnView() {
    let _trxnView;
    let _billIcon;
    switch (this.trxnView) {
      case 'B':
        // _timeIcon = '<i class="fas fa-fw fa-hourglass-start"></i>';
        _trxnView = 'All';
        break;
      case 'Y':
        // _timeIcon = '<i class="fas fa-fw fa-hourglass-end"></i>';
        _trxnView = 'Billed';
        break;
      case 'N':
        // _timeIcon = '<i class="fas fa-fw fa-hourglass"></i>';
        _trxnView = 'Unbilled';
        break;
      default:
        // _timeIcon = '<i class="fas fa-fw fa-hourglass"></i>';
        _trxnView = 'All';
        break;
    }
    return '<i class="fas fa-fw fa-funnel-dollar"></i>' + 'View ' + _trxnView + ' transactions';
  }

  async changeTrxnView() {

    let actionSheet = this.actionSheetCtl.create({
      buttons:
        [{
          text: 'Unbilled only',
          handler: () => {
            this.trxnView = 'N';
            this.getPlayerClubTransactions();
          }
        },
        {
          text: 'Billed only',
          handler: () => {
            this.trxnView = 'Y';
            this.getPlayerClubTransactions();
          }
        },
        {
          text: 'All',
          role: 'destructive', // will always sort to be on the bottom
          handler: () => {
            this.trxnView = 'B';
            this.getPlayerClubTransactions();
          }
        },
        ]
    });
    (await actionSheet).present();
  }

  doInfinite(infinite) {

    console.log("[do infinite]")
    if (this.isMore()) {
      // this._appendClubList(null, infinite);
      if (this.showPanel.transactions) this.getPlayerClubTransactions(infinite);
      if (this.showPanel.statements) this.getPlayerClubStatements(infinite);
    } else {
      infinite.target.complete();
      infinite.target.enable(false);
    }

  }

  public isMore() {
    // return false
    // console.log("[do infinite] is more : ", this.clubTeeTimeSlotList.length + " / " + this.allClubTeeTimeList.length)
    if (this.showPanel.transactions)
      return this.playerClubTransactionPage.totalItems > 0 && this.playerClubTransactionPage.currentPage < this.playerClubTransactionPage.totalPages;
    else if (this.showPanel.statements)
      return this.playerClubStatementPage.totalItems > 0 && this.playerClubStatementPage.currentPage < this.playerClubStatementPage.totalPages;
    else return false;
    // return this.playerList.totalPages > 0 && this.playerList.currentPage < this.playerList.totalPages;
  }

  async onStatementDetailsClick(statement: PlayerClubAccountStatement) {
    console.log("on statement details click : ", statement)
    let clubListModal = await this.modalCtl.create({
      component: PlayerStatementDetailsPage,
      componentProps: {
        openedModal: true,
        statementId: statement.id,
      }
    });
    clubListModal.onDidDismiss().then((data: any) => {
    });
    clubListModal.present();
  }

  getPlayerClubAccount() {
    let _clubId = this.clubMembership.club.id;
    let _playerId = this.clubMembership.player.id;
    let _params = {
      clubId: _clubId,
      playerId: _playerId
    }
    this.flightService.getPlayerClubAccount(_params)
      .subscribe((data) => {
        console.debug("get player club account : ", data)
      })
  }

  backButtonClick() {
    console.debug("back button click", this.showPanel)
  }

  toggleHistoryYearly(type?: string) {
    // this.historyYearly = !this.historyYearly;
    if(type === 'yearly') {
      this.historyYearly = true;
      this.playerClubStatementPage = createPlayerClubAccountStatementPage();
    } else if(type === 'lastNmonths') {
      this.historyYearly = false;
      this.playerClubStatementPage = createPlayerClubAccountStatementPage();
    } else {

      this.playerClubStatementPage = createPlayerClubAccountStatementPage();
    }
    if (!this.historyYearly) this.getPlayerClubStatements(null, false)
    else this.getPlayerClubStatements(); 
  }

  toggleTrxnHistory(type?: string) {
    if(type === 'monthly') {
      this.historyMonthly = true;
    } else if(type === 'periodDate') {
      this.historyMonthly = false;
    } else {
      this.historyMonthly = !this.historyMonthly;
    }
    this.confirmDate('past');
  }

  // async openMembershipDetail(clubInfo: ClubInfo, editMode?: boolean) {
  //   let _editMode = editMode;
  //   let _player;
  //   this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
  //     _player = player;
  //   });
  //   let modal = await this.modalCtl.create({
  //     component: PlayerAddClubMembershipPage,
  //     componentProps: {
  //       clubInfo: clubInfo,
  //       player: this.player$,
  //       editMode: _editMode,
  //       clubMembership: this.clubMembership
  //     }
  //   });
  //   modal.onDidDismiss().then((data: any) => {
  //     if (!!data && data.data.membership && _editMode) {
  //       this.refreshClubMembership();
  //     }
  //   });
  //   modal.present();
  // }

  refreshClubMembership() {
    if (!this.clubMembership) return;
    let _clubId;
    let _membershipId;
    let _playerId;
    if (this.clubMembership) {
      _clubId = this.clubMembership.club.id;
      _membershipId = this.clubMembership.id;
    }
    this.flightService.getSpecificClubMembership(_clubId, _membershipId)
      .subscribe((data) => {
        if (data) {
          this.clubMembership = data;
          _playerId = this.clubMembership.player.id;
          this.currentPlayerId = this.clubMembership.player.id;
          this.getPlayersCredits(this.currentPlayerId, this.clubMembership.club.id);
          this.getPlayerClubStatements(null, true);
          this.getPlayerClubAccount();
          this.getPlayerClubStats(1);
        }
      })

  }

  getPlayerBalance(inNumber?: number) {
    if (inNumber) return this.playerBalance;
    return this.mg2uUtil.numberWithCommas(this.playerBalance.toFixed(2)); //.toFixed(2);
  }

  stmtLastNMonths = 6;
  async getPlayerClubStats(lastNMonths?: number) {
    let _lastNMonths = lastNMonths ? lastNMonths : this.stmtLastNMonths;
    let _clubId = this.clubMembership.club.id; //this.clubInfo.clubId;
    let _playerId = this.currentPlayerId ? this.currentPlayerId : this.clubMembership.club.id;
    let loader = this.loadingCtrl.create({
      showBackdrop: false
    });
    (await loader).present().then(() => {
      // use player club account
      if(1) {
        let _params = {
          clubId: _clubId,
          playerId: _playerId,
        }
      this.flightService.getPlayerClubAccount(_params)
      .subscribe(async (data: PlayerClubAccount) => {
        if (data) {
          if(data.effectiveBalance !== undefined && data.effectiveBalance < 0) {
            this.playerBalance = data.effectiveBalance * -1;
          } else this.playerBalance = data.effectiveBalance;
          this.playerAccountDetails = data;
          console.debug("Player Club Account Stats : ", data)
        }

        if (loader) (await loader).dismiss();
      }, async (error) => {
        if (loader) (await loader).dismiss();
      });
      } else {
        this.flightService.getPlayerAccountStats(_clubId, _playerId, _lastNMonths)
          .subscribe(async (data: PlayerClubStat) => {
            if (data) {
              this.playerBalance = data.currentBalance;
              this.playerAccountDetails = data;
              console.debug("Player Club Account Stats : ", data)
            }
  
            if (loader) (await loader).dismiss();
          }, async (error) => {
            if (loader) (await loader).dismiss();
          });

      }
    });
  }

  playerAccountDetails: any;
  async onClickMakePayment() {
    console.debug("Player Club Account Stats : ", this.playerBalance, this.playerAccountDetails, this.clubMembership)
    let paymentModal = await this.modalCtl.create({
      component: PlayerPayClubMembershipPage,
      cssClass: 'ion-infinite-scroll',
      componentProps: {
        accountDetails: this.playerAccountDetails,
        clubInfo: this.clubMembership.club,
        clubMembership: this.clubMembership,
      }
    });
    paymentModal.onDidDismiss().then((data: any) => {
      this.onRefreshClick();
    });
    paymentModal.present();
  }

  close() {
    this.modalCtl.dismiss();
  }
  backRouting() {
    this.modalCtl.dismiss();
  }

  getLatestStmtDate() {
    console.debug("get latest stmt date ", this.getClubStatementList())
    if(!this.getClubStatementList() || this.getClubStatementList()?.length === 0) return this.getCurrentDate();
    let _length = this.getClubStatementList()?.length | 0;
    if(!_length) return this.getCurrentDate();
    else {
      let _date = moment(this.getClubStatementList()[_length-1].statementDate,"YYYY-MM-DD").format("DD MMM YYYY");
      return _date;
    }
  }

  onClicKUpdateMembershipInfo() {
    this.openMembershipDetail(this.clubMembership.club, true)
  }

  
  async openMembershipDetail(clubInfo: any, editMode: boolean = false, membership?: ClubMembershipExtended) {
    let _player;
    this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
      _player = player;
    });
    let modal = await this.modalCtl.create({
      component: PlayerAddClubMembershipPage,
      componentProps: {
        clubInfo: clubInfo,
        player: this.player$,
        editMode: editMode,
        clubMembership: this.clubMembership,
      }
    });
    modal.onDidDismiss().then((data: any) => {
      console.debug("membership detail dismiss", data)
      if(data) {
        this.onRefreshClick();
      } else {
        this.modalCtl.dismiss();
      }
    });
    modal.present();
  }

  getMemberImage() {
    let _memberImage = '';
    if(this.clubMembership?.memberImage) _memberImage = this.clubMembership.memberImage;
    else if(this.clubMembership?.player?.profile) _memberImage = this.clubMembership.player.profile
    else if(this.clubMembership?.player?.image) _memberImage = this.clubMembership.player.image;

    if(_memberImage.toLowerCase().includes(global.MygolfServerHost.toLowerCase()))
      return _memberImage
    else return global.MygolfServer + '/' + _memberImage;
  }

  
  async onMoreMenuItems() {
    let moreMenuItemLists = [
      { label: 'Refresh', value: 'refresh' },
      { label: 'View Other Clubs', value: 'otherClubs' },
    ];
    let popover = await this.popoverCtl.create({
      component: MoreMenuPopoverComponent,
      event: event,
      mode: 'ios',
      cssClass: 'popoverWidth',
      componentProps: {
        moreMenuItemLists: moreMenuItemLists,
      },
    });
    popover.present();
    await popover.onDidDismiss().then((data) => {
      if (data?.data) {
        switch (data?.data) {
          case 'refresh':
            this.onRefreshClick();
            break;
          case 'otherClubs':
            this.goListClubMemberships();
            break;
        }
      }
    });
  }
  
}
